import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { CardListItem, CardListItemProps, CardListItemSize } from 'record-it-components/cardList/CardListItem/CardListItem';
import { CardListItemIconButton } from 'record-it-components/cardList/CardListItemIconButton/CardListItemIconButton';
import { CardListItemTitle } from 'record-it-components/cardList/CardListItemTitle/CardListItemTitle';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { WorkTimeEntryBreak } from 'record-it-time-common/entity/entities/WorkTimeEntry/WorkTimeEntryDto';
import { DateUtils } from 'record-it-utils/utils/DateUtils/DateUtils';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
export type WorkTimeEntryBreakListItemProps = PropsWithoutChildren<CardListItemProps> & {
  workTimeEntryBreak: WorkTimeEntryBreak;
  onDelete: (workTimeEntryBreak: WorkTimeEntryBreak) => void;
};
export const WorkTimeEntryBreakListItem: FunctionComponent<WorkTimeEntryBreakListItemProps> = React.memo(props => {
  const $ = _c(20);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let onDelete;
  let remainingProps;
  let workTimeEntryBreak;
  if ($[2] !== t0) {
    ({
      workTimeEntryBreak,
      onDelete,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = onDelete;
    $[4] = remainingProps;
    $[5] = workTimeEntryBreak;
  } else {
    onDelete = $[3];
    remainingProps = $[4];
    workTimeEntryBreak = $[5];
  }
  let t1;
  if ($[6] !== onDelete || $[7] !== workTimeEntryBreak) {
    t1 = () => {
      onDelete(workTimeEntryBreak);
    };
    $[6] = onDelete;
    $[7] = workTimeEntryBreak;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const handleDeleteIconClick = useEventCallback(t1);
  let t2;
  if ($[9] !== workTimeEntryBreak.endDate || $[10] !== workTimeEntryBreak.startDate) {
    t2 = DateUtils.withCurrentTimezone().formatDateRange(workTimeEntryBreak.startDate, workTimeEntryBreak.endDate);
    $[9] = workTimeEntryBreak.endDate;
    $[10] = workTimeEntryBreak.startDate;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== t2) {
    t3 = <CardListItemTitle>{t2}</CardListItemTitle>;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== handleDeleteIconClick) {
    t4 = <CardListItemIconButton {...iconConfigurations.prefixed.listItem.deleteIcon} onClick={handleDeleteIconClick} data-testid="WorkTimeEntryBreakListItem.DeleteIcon" />;
    $[14] = handleDeleteIconClick;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== remainingProps || $[17] !== t3 || $[18] !== t4) {
    t5 = <CardListItem size={CardListItemSize.Small} {...remainingProps}>{t3}{t4}</CardListItem>;
    $[16] = remainingProps;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
});